// src/services/api.js
import axios from "axios";

// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Use the environment variable
  withCredentials: true, // Crucial! This sends cookies (like the auth token) back and forth
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Response Interceptor (Example: Global error handling)
apiClient.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    console.error("API Error:", error.response || error.message);

    if (error.response && error.response.status === 401) {
      // Handle Unauthorized errors (e.g., token expired, not logged in)
      // Option 1: Redirect to login - This might be too aggressive globally
      // window.location.href = '/login';

      // Option 2: Dispatch a logout action (if using Redux/Context)
      // store.dispatch({ type: 'LOGOUT' });

      // Option 3: Simply let the calling service/component handle it
      console.error("Unauthorized request - Session likely expired.");
    }

    // Return the error so that catch blocks in services/components can handle it
    return Promise.reject(error);
  }
);

export default apiClient;
